/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdGridProps, TdGridItemProps } from './type';

export const gridDefaultProps: TdGridProps = { align: 'center', border: false, column: 4, theme: 'default' };

export const gridItemDefaultProps: TdGridItemProps = { badge: null, layout: 'vertical' };
